export default {"src":"/_next/static/media/logout-icon.5bdb917e.svg","height":16,"width":17};